import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCommercialModel } from './commercialThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCommercialKey } from '../../sell/sellKeys';
const SLICE_NAME = 'model';

export const modelSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCommercialModel(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCommercialModel }).addCase(
            clearCommercialKey,
            () => commonInitialState,
        );
    },
});

export const { clearCommercialModel } = modelSlice.actions;

export const model = modelSlice.reducer;
